import React from 'react'
import I18n from 'lib/i18n'

import SlideOne from './slides/slide-one'
import SlideTwo from './slides/slide-two'
import SlideThree from './slides/slide-three'
import SlideFour from './slides/slide-four'

export default function StudentSlides ({ slideIndex }) {
  const slidesMap = {
    1: <SlideOne slideIndex={slideIndex} />,
    2: <SlideTwo slideIndex={slideIndex} />,
    3: <SlideThree slideIndex={slideIndex} />,
    4: <SlideFour slideIndex={slideIndex} />
  }
  return (
    <div className='students-slides slider-content' style={{ minHeight: I18n.locale === 'fr' ? 330 : 290 }}>
      {slidesMap[slideIndex]}
    </div>
  )
}
